import { FC } from 'react';
import { DriveItem } from '@microsoft/microsoft-graph-types';
import { withBestEffort } from '../error/BestEffort';
import { useGetItem } from '../../services/graph/hooks/onedrive';
import strings from './onedrive.translations';
import { useCustomerId } from '../../services/authentication/hooks/user';

interface Props {
  file: DriveItem;
}

const DocumentCategoryContent: FC<Props> = ({ file }) => {
  if (!file.parentReference?.id) {
    throw Error("Could not get parent id");
  }

  const myDirectoryId = useCustomerId();
  const [response] = useGetItem(file.parentReference.id) as any;
  const parentPath: string = response.webUrl;

  if (!parentPath) {
    throw Error("Could not get parent path");
  }

  let categoryName: string | undefined;

  if (file.parentReference.id === myDirectoryId) {
    categoryName = strings.documentList.myDocuments;
  } else {
    const splitParentPath = parentPath.split('/');
    const indexOfShared = splitParentPath.findIndex(path => path === "Shared");
    if (indexOfShared >= 0) {
      categoryName = splitParentPath[indexOfShared + 1].replaceAll("%20", " ");
    }
  }

  if (!categoryName) {
    throw Error("Could not parse category name");
  }

  return <div className="bg-primary-900 w-full p-1 text-white uppercase font-semibold text-center">{categoryName}</div>;
};

export const DocumentCategory = withBestEffort(DocumentCategoryContent);